export default class checkNIPMultipleAddress {

  constructor() {
    // SOAP on the server must be enabled!
    this.inputNIP      = document.getElementById("shipping_vat_number");
    this.getDataWait   = document.getElementById("vat_number-gusApi");
    this.addAddres     = document.getElementById("add_address");

    if (this.addAddres) {
      this.events()
    }
  }

  events() { 
    document.addEventListener('input',function(e){
      if(e.target && e.target.id == 'shipping_vat_number') {
        if (e.target.value.length === 10 || e.target.value.length > 10 && (isNaN(e.target.value) == true)) {
          let data = {
            'action': 'checkNIP',
            'nip': e.target.value
          }
          
          jQuery.ajax({
              url: ajax.ajaxurl,
              type: 'POST',
              data: data,
              beforeSend:function() {
                document.getElementById('vat_number-gusApi').style.display = "block";
                document.getElementById('vat_number-gusApi').innerHTML = "Pobieranie danych...";
              },
              success: function (response) {
                if (response.includes('StatusSesji:1')) {
                  document.getElementById('vat_number-gusApi').innerHTML = "NIP niepoprawny - nie znaleziono podmiotu";
                } else {
                  if ((isNaN(data.nip) == true)) {
                      document.getElementById('vat_number-gusApi').innerHTML = response.replace(/['"]+/g, '');
                  } else {
                    let obj = JSON.parse(response);
                    let closest = e.target.closest("div");
                    
                    closest.querySelector("input[name='shipping_address_1[]']").value = obj.street;
      
                    if (obj.a_number != "") {
                      closest.querySelector("input[name='shipping_address_2[]']").value = obj.s_number + "/" + obj.a_number;
                    } else {
                      closest.querySelector("input[name='shipping_address_2[]']").value = obj.s_number
                    }
                    
                    closest.querySelector("input[name='shipping_postcode[]']").value = obj.zipCode;
                    closest.querySelector("input[name='shipping_city[]']").value = obj.city;
                    closest.querySelector("input[name='shipping_company[]']").value = obj.name;
        
                    document.getElementById('vat_number-gusApi').style.display = "none";
                  }
                }
              },
              error: function (request) {
                console.log(request.responseText);
              }
          });   
        }
      }
    });
  }
}